module.exports = __webpack_public_path__ + "static_pc/img/footLogoRight.20113f6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/index/footLogoRight.png
// module id = 35fC
// module chunks = 1